module.exports = __webpack_public_path__ + "static/img/star-light.ffbbd241.png";